// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"19":"richtext","736":"vendor"}[chunkId] || chunkId) + "." + {"19":"e7f4af91","136":"7c553b73","147":"029ea02b","219":"e313a3b6","267":"f02993e7","416":"c3a9c2c5","482":"009ff0dc","736":"edb3b0cd","840":"1956d5e7","967":"2644c450"}[chunkId] + ".chunk.js";
};